define('drops/sap/sap',[
    'jquery',
    'lq/drop'
], function ($, Drop) {
    'use strict';

    function SAP(options) {
        Drop.call(this, $('<div/>'), options);
    };

    Drop.extend(SAP);

    SAP.typeName = 'SAP';

    SAP.prototype.preRender = function () {
        var self = this;
    };

    SAP.prototype.execute = function () {

        var data = {
            actionId: this.parent.data.id,
            morphId: this.data.id,
            parameters: this.piping.parameters.getNonSystemParameters(),
            eventActionType: "SAP"
        };

        this.piping.dispatcher.dispatch('Query/ExecuteSAPCommand', data)
            .done(function (result) {

            });
    };

    return SAP;
});







